import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CryptFormComponent } from './crypt-form.component';
import { FileSizeModule } from 'ngx-filesize';
import { ExtensionPipe } from '../pipes/extension.pipe';
import { FileItemComponent } from '../file-item/file-item.component';
import { FormsModule } from '@angular/forms';
import { DebounceDirective } from '../debounce.directive';
import { SubtleCryptService } from '../services/subtle-crypt.service';

@NgModule({
  declarations: [CryptFormComponent, ExtensionPipe, FileItemComponent, DebounceDirective],
  imports: [
    CommonModule,
    FileSizeModule,
    FormsModule
  ],
  providers: [SubtleCryptService],
  exports: [CryptFormComponent]
})
export class CryptFormModule { }
